import React from 'react'

const Team = () => {
    return (
        <div>
             {/* <!-- Our team start --> */}
            <div className="our-team content-area">
                <div className="container">
                    {/* <!-- Main title --> */}
                    <div className="main-title">
                        <h1>Nuestros Agentes</h1>
                        <p>Estamos para ayudarte en tu proceso de importacion</p>
                    </div>
                    {/* <!-- Slick slider area start --> */}
                    <div className="slick-slider-area clearfix">
                        <div className="row slick-carousel" data-slick='{"slidesToShow": 2, "responsive":[{"breakpoint": 1024,"settings":{"slidesToShow": 2}}, {"breakpoint": 768,"settings":{"slidesToShow": 1}}]}'>

                            <div className="slick-slide-item">
                                <div className="team-3">
                                    <div className="photo">
                                        <a href="#">
                                            <img src="http://placehold.it/350x379" alt="team-3" className="img-fluid"/>
                                        </a>
                                        <div className="social-list clearfix">
                                            <a href="#" className="facebook-bg"><i className="fa fa-facebook"></i></a>
                                            <a href="#" className="twitter-bg"><i className="fa fa-twitter"></i></a>
                                            <a href="#" className="google-bg"><i className="fa fa-google"></i></a>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <h4><a href="agent-detail.html">Daniel Hernandez</a></h4>
                                        <h5>CEO WTI Services</h5>
                                        <h6>+52 656 441 5210</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="slick-slide-item">
                                <div className="team-3">
                                    <div className="photo">
                                        <a href="#">
                                            <img src="http://placehold.it/350x379" alt="team-3" className="img-fluid"/>
                                        </a>
                                        <div className="social-list clearfix">
                                            <a href="#" className="facebook-bg"><i className="fa fa-facebook"></i></a>
                                            <a href="#" className="twitter-bg"><i className="fa fa-twitter"></i></a>
                                            <a href="#" className="google-bg"><i className="fa fa-google"></i></a>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <h4><a href="agent-detail.html">Daniel Hernandez</a></h4>
                                        <h5>CEO WTI Services</h5>
                                        <h6>+52 656 441 5210</h6>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Our team end --> */}            
        </div>
    )
}

export default Team


// WEBPACK FOOTER //
// ./src/components/Team.jsx